<template>
  <div class="activity-info" v-if="activity">
    <div class="activity-info-box" v-show="!edit">
      <a-card :bordered="false" :body-style="bodyStyle" title="基本信息">
        <a-space slot="extra">
          <a-popover v-model="qs" placement="leftTop">
            <div class="activity-qr" slot="content">
              <img :src="qr" class="activity-qr-img" v-if="qr">
              <div class="activity-qr-loading" v-else>
                <a-spin>
                  <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
                </a-spin>
              </div>
            </div>
            <a-button size="small" shape="circle" icon="qrcode" />
          </a-popover>
          <a-tooltip>
            <template slot="title">编辑活动</template>
            <a-button size="small" shape="circle" icon="edit" @click="editActivity" v-if="editable"/>
          </a-tooltip>
        </a-space>
        <detail-view :list="activity.detailList" style="width: 800px">
          <template v-slot:cover>
            <img :src="activity.cover" class="activity-cover" v-if="activity.cover">
            <span v-else>无</span>
          </template>
          <template v-slot:chargeUser>
            <person-item bordered :person="activity.chargeUser" v-if="activity.chargeUser"/>
            <span v-else>未设置</span>
          </template>
          <template v-slot:chargeGroup>
            <div class="activity-charge-group" v-if="activity.charge_group && activity.charge_group.length > 0">
              <person-item bordered :person="item" v-for="item in activity.charge_group" :key="item.id" />
            </div>
            <span v-else>未设置</span>
          </template>
          <template v-slot:schedule>
            <router-link :to="{name: 'ActivityGroup'}">查看</router-link>
          </template>
          <template v-slot:info>
            <div
              class="rich-preview"
              v-html="activity.info"
              v-if="activity.info"
            ></div>
            <span v-else>无</span>
          </template>
        </detail-view>
      </a-card>
    </div>
    <form-area
      class="activity-info-box"
      layout="horizontal"
      :label-col="{ span: 5 }"
      :wrapper-col="{ span: 19 }"
      :items="items"
      :entity="form"
      @cancel="handleCancel"
      @confirm="handleConfirm"
      confirm-text="提交"
      v-show="edit"></form-area>
  </div>
</template>

<script>
import { dealActivity, getEditActivityForm } from "../../common/activity/activity";
import config from "../../common/js/config";
import DetailView from "../../components/detail-view";
import personItem from "../../components/person-item";
import mixins from "./mixins";

export default {
  name: "ActivityDetail",
  components: {
    DetailView,
    personItem
  },
  data() {
    return {
      qs: false,
      loading: false,
      qr: null,
      bodyStyle: {padding: '8px 0'},
      form: {},
      info: null,
      edit: false
    };
  },
  computed: {
    activity() {
      let res = null;
      const activity = this.$store.getters.activity;
      if (activity) {
        res = { ...activity };
        dealActivity(res);
        res.detailList.push(
          {label: '活动封面', scopedSlot: "cover"},
          {label: '统筹人', scopedSlot: "chargeUser"},
          {label: '统筹小组', scopedSlot: "chargeGroup"},
          {label: '官方日程', scopedSlot: "schedule"},
          {label: '活动介绍', scopedSlot: "info"},
        )
        // this.getDecorateInfo(activity);
      }
      return res;
    },
    items() {
      let res = [];
      if(this.activity) {
          res = getEditActivityForm(this.activity.id)
      }
      return res;
    }
  },
  inject: ["parent"],
  mixins: [mixins],
  watch: {
    activity(){
      this.getActivityQr();
    }
  },
  created() {
    this.getActivityQr();
  },
  methods: {
    getActivityQr() {
      if(this.activity && !this.qr) {
        const url = `/activity/live/share-code`;
        this.$axios({
          url,
          method: "POST",
          data: {
            path: `pages/home/home?activity_id=${this.activity.id}`
          }
        }).then(res => {
          this.qr = config.host + "/" + res.data;
        })
      }
    },
    handleCancel() {
      this.edit = false;
    },
    handleConfirm(form) {
      if (this.loading) return;
      this.loading = true;
      const data = {
        name: form.name,
        start_time: form.time[0],
        end_time: form.time[1],
        address: form.address,
        people_count: form.people_count,
        info: form.info,
        cover: form.cover,
        file: form.files ? JSON.stringify(form.files) : null,
        plan: JSON.stringify({
          create_user: {
            name: form.chargeUser.name,
            tel: form.chargeUser.tel
          },
          create_group: form.chargeGroup ? form.chargeGroup.map(g => Object({name: g.name, tel: g.tel})) : []
        })
      }
      const activity = this.activity;
      let url = `/activity/activity/${activity.id}`, method = "PATCH";
      this.$axios({
        url,
        method,
        data,
      })
        .then(() => {
          this.parent && this.parent.getActivity();
          this.edit = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    editActivity() {
      const activity = this.activity;
      const form = {
        name: activity.name,
        time: [activity.start_time, activity.end_time],
        address: activity.address,
        people_count: activity.people_count,
        info: activity.info,
        cover: activity.cover,
        chargeUser: activity.chargeUser ? {...activity.chargeUser} : null,
        chargeGroup: [...activity.charge_group],
      }
      if(activity.file) {
        try {
          form.files = JSON.parse(activity.file);
        } catch (e) {
          console.error(e);
        }
      }
      this.form = form;
      this.edit = true;
    },
  },
};
</script>

<style scoped lang="less">
.activity-info {
  flex: 1;
  overflow: auto;
}
.activity-info-box {
  margin: @padding-md auto;
  width: 1200px;
  box-shadow: @box-shadow-base;
  background-color: @body-background;
}
.activity-qr {
  width: 200px;
  height: 200px;
}
.activity-qr-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.activity-qr-img {
  width: 100%;
  height: 100%;
}
.activity-charge-group {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .person-item {
    margin-right: 0.5em;
  }
}
.activity-cover {
  width: 200px;
  height: 100px;
  object-fit: cover;
}
</style>
